import { render, staticRenderFns } from "./TheNavbarTopPanel.vue?vue&type=template&id=54ec854b&scoped=true&"
import script from "./TheNavbarTopPanel.vue?vue&type=script&lang=js&"
export * from "./TheNavbarTopPanel.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarTopPanel.vue?vue&type=style&index=0&id=54ec854b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec854b",
  null
  
)

export default component.exports